import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/shop',
    name: 'Shop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelect.vue')
  }
  ,
  {
    path: '/select',
    name: 'ProductSelect',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelect.vue')
  }
  ,
  {
    path: '/select_t1',
    name: 'ProductSelectT1',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT1.vue')
  }
  ,
  {
    path: '/select_t2',
    name: 'ProductSelectT2',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT2.vue')
  }
  ,
  {
    path: '/select_t6',
    name: 'ProductSelectT6',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT6.vue')
  }
  ,
  {
    path: '/select_t3',
    name: 'ProductSelectT3',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT3.vue')
  }
  ,
  {
    path: '/cart',
    name: 'Cart',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cart.vue')
  }
  ,
  {
    path: '/confirm',
    name: 'Confirm',
    component: () => import(/* webpackChunkName: "about" */ '../views/Confirm.vue')
  },
  {
    path: '/confirmpaypal',
    name: 'ConfirmPayPal',
    component: () => import(/* webpackChunkName: "about" */ '../views/ConfirmPayPal.vue')
  },
  {
    path: '/provider',
    name: 'Provider',
    component: () => import(/* webpackChunkName: "about" */ '../views/Provider.vue')
  },
  {
    path: '/tc',
    name: 'TC',
    component: () => import(/* webpackChunkName: "about" */ '../views/TC.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/Privacy.vue')
  }
  ,
  {
    path: '/product',
    name: 'Product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Product.vue')
  }
  ,
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  }
  ,
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "about" */ '../views/FAQ.vue')
  }
  ,
  {
    path: '/review',
    name: 'Review',
    component: () => import(/* webpackChunkName: "about" */ '../views/Review.vue')
  }
  ,
  {
    path: '/compliance',
    name: 'Compliance',
    component: () => import(/* webpackChunkName: "about" */ '../views/Compliance.vue')
  }
  ,
  {
    path: '/rewards',
    name: 'Rewards',
    component: () => import(/* webpackChunkName: "about" */ '../views/Rewards.vue')
  }
  ,
  {
    path: '/distributor',
    name: 'Distributor',
    component: () => import(/* webpackChunkName: "about" */ '../views/Distributor.vue')
  }
  ,
  {
    path: '/cookies',
    name: 'Cookies',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cookies.vue')
  },
  {
    path: '/refund',
    name: 'Refund',
    component: () => import(/* webpackChunkName: "about" */ '../views/Refund.vue')
  },
  {
    path: '/warranty',
    name: 'Warranty',
    component: () => import(/* webpackChunkName: "about" */ '../views/Warranty.vue')
  }
  ,
  {
    path: '/select_t4',
    name: 'ProductSelectT4',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT4.vue')
  }
  ,
  {
    path: '/kiosk',
    name: 'Kiosk',
    component: () => import(/* webpackChunkName: "about" */ '../views/Kiosk.vue')
  }
  ,
  {
    path: '/select_t5',
    name: 'ProductSelectT5',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductSelectT5.vue')
  }
  
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

export default router
